<template>
  <div v-show="role === 'free'" class="w-full mx-auto mt-8 flex flex-col px-10">
    <div
      class="inline-flex justify-between py-4 rounded-md border w-full mt-6 p-6 bg-indigo-600 text-white"
    >
      <div class="flex gap-7 items-center">
        <div class="bg-indigo-700 rounded pt-1 pb-2 px-2 mr-2">
          <Icon name="LockOpen" class="w-6 h-6" />
        </div>
        <p class="text-white py-2">
          Want full access to Adbox, including 
          <span class="font-bold">{{ text }}</span
          >?
        </p>
      </div>

      <div class="flex gap-5">
        <router-link to="/pricing">
          <Button
            type="submit"
            class="px-5 my-0 py-0 bg-white hover:bg-indigo-400 text-indigo-600 rounded-md"
          >
            Join now
          </Button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import Button from "@/components/UI/Button";
import Icon from "@/components/UI/Icon";

export default {
  components: { Icon, Button },
  props: {
    text: String,
  },
  setup() {
    const store = useStore();

    const loading = ref(false);

    const role = computed(() => store.state.role);

    return { role, loading };
  },
};
</script>

<style>
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 9px;
  margin: 7.2px 0;
}
.lds-ellipsis div {
  position: absolute;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 24px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 42px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(18px, 0);
  }
}
</style>
